import { motion } from 'framer-motion';
import { Heart } from 'lucide-react';
import { Facebook, Instagram } from 'lucide-react';


export default function Footer() {
  const scrollToContact = () => {
    const el = document.querySelector('#contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer
      className="py-16 md:py-24 relative overflow-hidden"
      style={{ backgroundColor: 'var(--primary)', color: 'var(--primary-fg)' }}
      data-testid="footer-section"
    >
      {/* Decorative faded circles */}
      <div className="absolute top-0 right-0 w-64 h-64 rounded-full border border-white/10 float-anim pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-48 h-48 rounded-full border border-white/5 float-anim-reverse pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
        {/* Large CTA Text */}
        <motion.button
          onClick={scrollToContact}
          className="block w-full text-left bg-transparent border-none cursor-pointer group"
          data-testid="footer-cta"
          whileHover={{ scale: 1.01 }}
          transition={{ duration: 0.3 }}
        >
          <h2
            className="font-heading font-light tracking-tighter leading-none transition-opacity duration-300 group-hover:opacity-80"
            style={{ fontSize: 'clamp(3rem, 10vw, 10rem)', color: 'var(--primary-fg)' }}
          >
            LET'S
            <br />
            <span className="italic">TALK</span>
          </h2>
        </motion.button>

        {/* Marquee strip */}
        <div className="overflow-hidden py-8 my-8 border-y border-white/10">
          <div className="marquee-track flex whitespace-nowrap gap-8" style={{ width: 'max-content' }}>
            {[...Array(6)].map((_, i) => (
              <span key={i} className="flex items-center gap-4 font-body text-sm uppercase tracking-[0.15em] text-white/40">
                <Heart size={10} className="fill-current" />
                Weddings
                <Heart size={10} className="fill-current" />
                Birthdays
                <Heart size={10} className="fill-current" />
                Events
                <Heart size={10} className="fill-current" />
                Invitations
              </span>
            ))}
          </div>
        </div>

        {/* Bottom Links */}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="flex items-center gap-2">
            <Heart size={14} className="fill-current text-white/60" />
            <p className="font-body text-sm text-white/60">
              &copy; {new Date().getFullYear()} CelebrationCraft. All rights reserved.
            </p>
          </div>
          <div className="flex gap-8">
            {['Portfolio', 'About', 'Contact'].map((label) => (
              <motion.button
                key={label}
                onClick={() => {
                  const el = document.querySelector(`#${label.toLowerCase()}`);
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }}
                className="font-body text-sm text-white/60 hover:text-white transition-colors bg-transparent border-none cursor-pointer"
                data-testid={`footer-link-${label.toLowerCase()}`}
                whileHover={{ y: -2 }}
              >
                {label}
              </motion.button>
            ))}


 <div className="flex gap-3 items-center">
  <a
    href="https://www.facebook.com/profile.php?id=61573667742369"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Facebook"
    className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition"
  >
    <Facebook size={20} />
  </a>

  <a
    href="https://instagram.com/sh_invite"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Instagram"
    className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition"
  >
    <Instagram size={20} />
  </a>
</div>
          </div>
        </div>
        
      </div>

      <a
        href="https://wa.me/94765489955"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 inline-flex items-center justify-center rounded-full bg-[#25D366] p-2 shadow-2xl shadow-black/20 transition-transform duration-300 hover:-translate-y-1"
        aria-label="Chat on WhatsApp"
      >
        <svg viewBox="0 0 24 24" className="h-6 w-6 text-white" fill="currentColor" aria-hidden="true">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.472-.149-.672.15-.198.297-.768.967-.94 1.165-.173.198-.347.223-.644.075-.297-.149-1.255-.462-2.39-1.475-.883-.787-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.372-.025-.521-.075-.149-.672-1.612-.92-2.206-.242-.579-.487-.5-.672-.51l-.573-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.077 4.487.709.306 1.262.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.414.248-.697.248-1.296.173-1.414-.074-.118-.273-.198-.57-.347zm-5.472 4.994h-.001C6.5 19.96 2.04 15.5 2.04 9.98 2.04 4.46 6.5 0 12.02 0c5.52 0 10 4.46 10 9.98 0 5.52-4.48 9.996-9.99 9.996z"/>
        </svg>
      </a>
    </footer>
  );
}
